import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ParamsService } from 'uServices/params.service';
import { Storage } from '@ionic/storage-angular';
import { IonicModule } from '@ionic/angular';
import { AuthService } from 'uServices/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class AppComponent {
  constructor(private authSrv: AuthService,
              private params: ParamsService,
              private storage: Storage,
              private translate: TranslateService) {
    this.initializeApp();
  }

  async initializeApp() {
    // const before_1: any = new Date();
    console.log('AppComponent:  initializeApp start: ' + new Date().toLocaleTimeString());
    this.translate.addLangs(['en', 'ru', 'ua']);
    this.translate.setDefaultLang('ua');
    this.translate.use('ua');
    await this.storage.create();
    await this.authSrv.loadFromStorage();
    // await this.params.initParams();
    // this.params.initParams();
    this.authSrv.listenForLogout();
    console.log('AppComponent:  initializeApp finish: ' + new Date().toLocaleTimeString());
    // console.log('AppComponent:  initializeApp finish after ' + (Date.now() - before_1) + ' ms');
  }
}
